// extracted by mini-css-extract-plugin
export default {"taskEvaluationContainer":"TaskEvaluationList_taskEvaluationContainer__HLnM3"};